import { fetchWithHandling } from "utils/common-utils";
import { Customer, Filters, PagedCustomers } from "utils/interfaces";

const API_URL = `${process.env.REACT_APP_BACKEND_API_PREFIX}/api/v1/customers`

export interface CreateCustomerRequest {
    fullName: string;
    vatNumber?: string;
    taxCode?: string;
    email?: string;
    phone?: string;
    address?: string;
    addressCity?: string;
    addressZip?: string;
    addressState?: string;
}

export const create = async (
    jwtToken: string,
    onSessionExpired: () => void,
    data: CreateCustomerRequest
): Promise<Customer | undefined> => {
    try {
        const jsonData = await fetchWithHandling(
            API_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
                body: JSON.stringify(data),
            },
            () => {
                onSessionExpired();
            }
        );
        return jsonData as Customer | undefined;
    } catch (error) {
        return undefined;
    }
};

export const getAllPaginated = async (
    jwtToken: string,
    onSessionExpired: () => void,
    filters: Filters<any> = {}
): Promise<PagedCustomers | undefined> => {
    try {
        // Crea la stringa dei query parameters a partire dai filtri
        const queryParams = new URLSearchParams();

        if (filters.fullName) {
            queryParams.append('fullName', filters.fullName);
        }
        if (filters.pageNumber !== undefined) {
            queryParams.append('pageNumber', String(filters.pageNumber));
        }
        if (filters.pageSize !== undefined) {
            queryParams.append('pageSize', String(filters.pageSize));
        }

        // Aggiungi i parametri alla URL
        const url = queryParams.size > 0 ? `${API_URL}/paginated?${queryParams.toString()}` : `${API_URL}/paginated`;

        const jsonData = await fetchWithHandling(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData;
    } catch (error) {
        return undefined;
    }
};

export const getAllNotPaginated = async (
    jwtToken: string,
    onSessionExpired: () => void,
    filters: Filters<any> = {}
): Promise<Customer[] | undefined> => {
    try {
        // Crea la stringa dei query parameters a partire dai filtri
        const queryParams = new URLSearchParams();

        if (filters.fullName) {
            queryParams.append('fullName', filters.fullName);
        }

        // Aggiungi i parametri alla URL
        const url = queryParams.size > 0 ? `${API_URL}?${queryParams.toString()}` : `${API_URL}`;

        const jsonData = await fetchWithHandling(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${jwtToken}`,
                },
            },
            () => {
                onSessionExpired();
            }
        );

        return jsonData;
    } catch (error) {
        return undefined;
    }
};